import { Button, Form, Input, InputNumber, Select } from "antd";
import { filterOption, requiredField } from "../common/common";
import { useEffect, useState } from "react";
import axiosInstance from "../common/api";
import { useNavigate } from "react-router";

export default function () {
  const [loading, setLoading] = useState(false);
  const [courseTypes, setCourseTypes] = useState([]);
  const navigate = useNavigate();
  const onFinish = (data) => {
    setLoading(true);
    axiosInstance
      .post("appointmentType", data)
      .then(() => navigate(-1))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    axiosInstance
      .get("courseType", { params: { pageSize: 99999 } })
      .then(({ data }) => setCourseTypes(data.data.map((x) => ({ label: x.title, value: x.id }))));
  }, []);

  return (
    <Form onFinish={onFinish} layout="vertical" autoComplete="off">
      <Form.Item label="Nome" rules={[requiredField]} name="name">
        <Input />
      </Form.Item>
      <Form.Item label="Corso richiesto" rules={[requiredField]} name="courseType">
        <Select options={courseTypes} showSearch filterOption={filterOption} />
      </Form.Item>
      <Form.Item>
        <Button type="primary" htmlType="submit" loading={loading}>
          Conferma
        </Button>
      </Form.Item>
    </Form>
  );
}
